import React, { useState } from 'react';
import ObliqueIcon from '@/components/icons/ObliqueIcon';
import { motion } from 'framer-motion';

export default function NotificationsSettings() {
    const [emailDigest, setEmailDigest] = useState('Daily');
    const [desktopNotifications, setDesktopNotifications] = useState(true);
    const [soundEnabled, setSoundEnabled] = useState(true);
    const [marketingEmails, setMarketingEmails] = useState(false);

    const SectionTitle = ({ title }) => (
        <h3 style={{ fontSize: '13px', fontWeight: '500', color: 'var(--text-primary)', marginBottom: '16px', marginTop: '32px' }}>
            {title}
        </h3>
    );

    const Row = ({ label, description, rightElement }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
            <div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: 'var(--text-primary)', marginBottom: '4px' }}>{label}</div>
                {description && <div style={{ fontSize: '12px', color: 'var(--text-tertiary)', fontWeight: '500', maxWidth: '400px', lineHeight: 1.4 }}>{description}</div>}
            </div>
            <div>{rightElement}</div>
        </div>
    );

    const Toggle = ({ active, onChange }) => (
        <button 
            onClick={() => onChange(!active)}
            style={{ 
                width: '36px', height: '20px', borderRadius: '10px', 
                background: active ? 'var(--accent)' : 'var(--bg-muted)', 
                border: 'none', position: 'relative', cursor: 'pointer',
                transition: 'background 0.2s'
            }}
        >
            <motion.div 
                animate={{ x: active ? 16 : 2 }} 
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                style={{ width: '16px', height: '16px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '2px' }} 
            />
        </button>
    );

    const Select = ({ value, options, onChange }) => (
        <select 
            value={value} onChange={e => onChange(e.target.value)}
            style={{ 
                padding: '6px 12px', borderRadius: '6px', border: '1px solid var(--border)', 
                background: 'var(--bg-surface)', color: 'var(--text-primary)', fontSize: '13px', fontWeight: '500',
                cursor: 'pointer', outline: 'none'
            }}
        >
            {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
    );

    return (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="animate-fade-in">
            <h2 style={{ fontSize: '20px', fontWeight: '500', color: 'var(--text-primary)', marginBottom: '8px', letterSpacing: '-0.02em' }}>Notifications</h2>
            <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', fontWeight: '500', marginBottom: '24px' }}>Control how you receive alerts and updates.</p>
            
            <SectionTitle title="App notifications" />
            <Row 
                label="Desktop notifications" 
                description="Receive push notifications when the app is open."
                rightElement={<Toggle active={desktopNotifications} onChange={setDesktopNotifications} />}
            />
            <Row 
                label="Notification sounds" 
                description="Play a sound when you receive a new notification."
                rightElement={<Toggle active={soundEnabled} onChange={setSoundEnabled} />}
            />

            <SectionTitle title="Email notifications" />
            <Row 
                label="Activity digest" 
                description="Receive a summary of updates and activity."
                rightElement={
                    <Select 
                        value={emailDigest} onChange={setEmailDigest}
                        options={[
                            { value: 'Instant', label: 'Instant' },
                            { value: 'Daily', label: 'Daily' },
                            { value: 'Weekly', label: 'Weekly' },
                            { value: 'Off', label: 'Off' }
                        ]}
                    />
                }
            />
            <Row 
                label="Product updates & marketing" 
                description="Receive occasional emails about new features and best practices."
                rightElement={<Toggle active={marketingEmails} onChange={setMarketingEmails} />}
            />
        </motion.div>
    );
}
